import * as React from "react";
import styled from "styled-components";
import { SearchSuggestions } from "@graylog/server-api";
import IconButton from "components/common/IconButton";
import { startAutocomplete } from "views/components/searchbar/queryinput/commands";
const QUERY_HISTORY_LIMIT = 100;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 6px;
`;
const fetchQueryHistoryCompletions = () => SearchSuggestions.suggestQueryStrings(QUERY_HISTORY_LIMIT).then(
  (response) => response.sort(
    ({ last_used: lastUsedA }, { last_used: lastUsedB }) => new Date(lastUsedB).getTime() - new Date(lastUsedA).getTime()
  ).map((entry, index) => ({
    value: entry.query,
    meta: "history",
    score: index,
    completer: {
      insertMatch: (editor, data) => {
        editor.setValue(data.value, 1);
      }
    }
  }))
);
export const displayHistoryCompletions = async (editor) => {
  const historyCompletions = await fetchQueryHistoryCompletions();
  if (historyCompletions == null ? void 0 : historyCompletions.length) {
    startAutocomplete(editor, { matches: historyCompletions });
  }
};
const QueryHistoryButton = ({ editorRef }) => {
  const showQueryHistory = async () => {
    if (editorRef.current) {
      editorRef.current.focus();
      displayHistoryCompletions(editorRef.current);
    }
  };
  return /* @__PURE__ */ React.createElement(ButtonContainer, null, /* @__PURE__ */ React.createElement(IconButton, { name: "history", onClick: showQueryHistory, title: "Open query history" }));
};
export default QueryHistoryButton;
